import React from 'react';
import {
  getQualifiedBannerMinProgression,
  isYearlyConsumptionOver2700Valid,
  CONSUMPTION_OVER_2700_THRESHOLD
} from '../../utils/pvConsumptionQualification';

const YesIcon = () => (
  <svg viewBox="0 0 24 24" className="yes-icon">
    <path
      d="M4 12.6L9 17.6L20 6.6"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NoIcon = () => (
  <svg viewBox="0 0 24 24" className="no-icon">
    <path
      d="M5 5L19 19M5 19L19 5"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DisqualifiedMessage = () => (
  <div className="qualification-message disqualified">
    <svg viewBox="0 0 24 24" className="qualification-icon">
      <path
        d="M5 5L19 19M5 19L19 5"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <span>Lead nicht Qualifiziert</span>
  </div>
);

function PvConsumptionQuestions({
  data,
  progression,
  onOver2700Change,
  onYearlyConsumptionChange,
  onRangeWith3MonthsChange,
  onRealizationTimeframeChange,
  showQualifiedBanner = false,
  isQualified = false,
  isDisqualified = false,
  isStepValid = false
}) {
  const minProgressionForBanner = getQualifiedBannerMinProgression(data);

  return (
    <>
      {progression >= 9 && (
        <div className="form-section">
          <label className="form-label required">kWh-Verbrauch {'>'} 2700?</label>
          <div className="yes-no-buttons">
            <button
              type="button"
              className={`yes-button ${data.consumptionOver2700 === true ? 'selected' : ''}`}
              onClick={() => onOver2700Change(true)}
            >
              <div className="icon-container">
                <YesIcon />
              </div>
              <span>Ja</span>
            </button>
            <button
              type="button"
              className={`no-button ${data.consumptionOver2700 === false ? 'selected' : ''}`}
              onClick={() => onOver2700Change(false)}
            >
              <div className="icon-container">
                <NoIcon />
              </div>
              <span>Nein</span>
            </button>
          </div>

          {data.consumptionOver2700 === true && (
            <div className="form-row" style={{ marginTop: '15px' }}>
              <div className="form-field">
                <label className="form-label required">Jahresverbrauch (kWh)</label>
                <input
                  type="number"
                  name="yearlyConsumption"
                  value={data.yearlyConsumption || ''}
                  onChange={(e) => onYearlyConsumptionChange(e.target.value)}
                  className="form-input"
                  placeholder={`z.B. ${CONSUMPTION_OVER_2700_THRESHOLD + 100}`}
                  min={CONSUMPTION_OVER_2700_THRESHOLD + 1}
                  required
                />
                {data.yearlyConsumption !== '' && !isYearlyConsumptionOver2700Valid(data.yearlyConsumption) && (
                  <div className="qualification-message disqualified">
                    <svg viewBox="0 0 24 24" className="qualification-icon">
                      <path
                        d="M5 5L19 19M5 19L19 5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Verbrauch muss über {CONSUMPTION_OVER_2700_THRESHOLD} kWh liegen</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {data.consumptionOver2700 === false && (
        <div className="form-section">
          <label className="form-label required">
            kWh 2300–2700 – Realisierung in 3 Monaten vorstellbar?
          </label>
          <div className="yes-no-buttons">
            <button
              type="button"
              className={`yes-button ${data.consumptionInRangeWith3Months === true ? 'selected' : ''}`}
              onClick={() => onRangeWith3MonthsChange(true)}
            >
              <div className="icon-container">
                <YesIcon />
              </div>
              <span>Ja</span>
            </button>
            <button
              type="button"
              className={`no-button ${data.consumptionInRangeWith3Months === false ? 'selected' : ''}`}
              onClick={() => onRangeWith3MonthsChange(false)}
            >
              <div className="icon-container">
                <NoIcon />
              </div>
              <span>Nein</span>
            </button>
          </div>

          {data.consumptionInRangeWith3Months === false && <DisqualifiedMessage />}
        </div>
      )}

      {data.consumptionOver2700 === true &&
        isYearlyConsumptionOver2700Valid(data.yearlyConsumption) &&
        progression >= 12 && (
        <div className="form-section">
          <label className="form-label required">Realisierungszeitraum innerhalb von 12 Monaten</label>
          <div className="yes-no-buttons">
            <button
              type="button"
              className={`yes-button ${data.hasRealizationTimeframe === true ? 'selected' : ''}`}
              onClick={() => onRealizationTimeframeChange(true)}
            >
              <div className="icon-container">
                <YesIcon />
              </div>
              <span>Ja</span>
            </button>
            <button
              type="button"
              className={`no-button ${data.hasRealizationTimeframe === false ? 'selected' : ''}`}
              onClick={() => onRealizationTimeframeChange(false)}
            >
              <div className="icon-container">
                <NoIcon />
              </div>
              <span>Nein</span>
            </button>
          </div>

          {data.hasRealizationTimeframe === false && <DisqualifiedMessage />}
        </div>
      )}

      {showQualifiedBanner &&
        progression >= minProgressionForBanner &&
        !isDisqualified &&
        isStepValid &&
        isQualified && (
          <div className="qualification-message qualified">
            <svg viewBox="0 0 24 24" className="qualification-icon">
              <YesIcon />
            </svg>
            <span>Lead ist Qualifiziert</span>
          </div>
        )}
    </>
  );
}

export default PvConsumptionQuestions;
